import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeWysiwyg } from 'src/shared/models/wysiwygResource.model';

const { WYSIWYG_DETAIL } = ResourceTypeDetailEnum;

export const buildChallengeWysiwyg = (
  resource: IResourceList
): IChallengeWysiwyg => {
  const { resourceDetailList, idResource, name: title } = resource;
  let item: IChallengeWysiwyg;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case WYSIWYG_DETAIL:
          item = {
            ...item,
            content: value,
          };
          break;
      }
    });

  return {
    ...item,
    idResource,
    title,
  };
};
